import * as UI from '../ui';
import rollbar from '../rollbar';
import Swal    from 'sweetalert2';


// Make HTTP status code to the specific message we can show the user.
const errorMessages = {
  500:     'Oops. Something went wrong. Please try again.',
  400:     'Sorry, cannot complete this request, missing some data.',
  401:     'Sorry, you need to sign in again.',
  403:     'Sorry, you are not allowed to perform this operation.',
  offline: 'No network connection, please try again later.'
};

// Inform Rollbar of server, network, and code errors.
export function sendToRollbar(error) {
  if (isRequestError(error) || isServerError(error))
    rollbar.error(error);
}

export function getFriendlyErrorMessage(error) {
  if (navigator && navigator.onLine === false)
    return errorMessages.offline;
  else
    return errorMessages[error.statusCode] || errorMessages[500];
}

// 400 propagates to app to deal with, typically show validation error.
// 401 will sign out user, do not show toast.
// We use toast message to show 403/405 and other uncommon client errors.
// We use toast message to show server/network error.
export function showToastError(error) {
  return function(dispatch) {
    if (typeof error === 'string')
      dispatch(UI.toast(error));
    else if (showClientError(error) || isServerError(error) || isRequestError(error)) {
      const message = getFriendlyErrorMessage(error);
      dispatch(UI.toast(message));
    }
  };
}

export function showDialogError(error) {
  if (typeof error === 'string') {
    Swal.fire({
      text: error,
      icon: 'error'
    });
  } else if (showClientError(error) || isServerError(error) || isRequestError(error)) {
    const message = getFriendlyErrorMessage(error);
    Swal.fire({
      text: message,
      icon: 'error'
    });
  }
}

export function shouldRetry(error) {
  const isIdempotent = [ 'GET', 'PATCH', 'PUT', 'DELETE' ].includes(error.method);
  return isIdempotent && (isServerError(error) || isRequestError(error));
}

// Server error: 5xx
function isServerError(error) {
  return (error.statusCode >= 500);
}

function showClientError(error) {
  return (error.statusCode > 401 && error.statusCode !== 404);
}


// Network error: 0 (CORS, timeout, aborted, etc)
// Code error: no status code
function isRequestError(error) {
  return (error.statusCode === 0 || error.statusCode === undefined);
}
